import React from 'react';
import SMStayReservationCalendarBaseView from './SMStayReservationCalendarBaseView';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';

class SMStayReservationCalendarMobileView extends SMStayReservationCalendarBaseView {

  constructor(props) {
    super(props);
  }

  renderMonthly() {
    let weekDay = 0;
    let rows = [];
    let cols = [];
    let calendars = this.state.isCheckinCalendar ? this.state.checkinCalendars : this.state.checkoutCalendars;
    const monthFirst = this.toYMD(new Date(Date.UTC(this.state.year, this.state.month - 1, 1)));
    const monthLast = this.toYMD(new Date(Date.UTC(this.state.year, this.state.month, 0)));
    const now = new Date();

    calendars.forEach((calendar, index)=>{
      let classes = [];
      const currentDate = new Date(Date.UTC(calendar.year, calendar.month - 1, calendar.day));
      const current = this.toYMD(currentDate);

      let isCurrentMonth = true;

      let checkinAt = null;
      if (this.state.checkinAt) {
        let checkinAtDate = new Date(this.state.checkinAt);
        checkinAt = this.toYMD(checkinAtDate);
      }

      let checkoutAt = null;
      if (this.state.checkoutAt) {
        let checkoutAtDate = new Date(this.state.checkoutAt);
        checkoutAt = this.toYMD(checkoutAtDate);
      }

      if (current < monthFirst) {
        isCurrentMonth = false;
      }
      if (current > monthLast) {
        isCurrentMonth = false;
      }
      if (current == this.toYMD(now)) {
        classes.push("is-today");
      }
      if (this.state.month == calendar.month && this.state.day == calendar.day) {
        classes.push("is-select");
      }
      if (checkinAt && checkinAt == current) {
        classes.push("is-checked is-reserved is-checkin");
      }
      if (checkoutAt && checkoutAt == current) {
        classes.push("is-checked is-reserved is-checkout");
      }
      if (checkinAt < current && current < checkoutAt) {
        classes.push("is-checked is-middle-reserved");
      }

      const key = current;

      if (!isCurrentMonth) {
        classes.push("is-past");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="sp-reserve-period__calendar-content" />
          </td>
        );
      }
      else if(calendar.status == SMConst.RoomStatus.Available) {
        const priceSuffix = this.props.isHourly ? "〜" : "";
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <a onClick={(e) => this.dayDidSelect(calendar, e)} href="#" className="dashboard-calendar__cell-wrap">
              <p className="dashboard-calendar__date">{calendar.day}</p>
              <div className="sp-reserve-period__calendar-content">
                <p className="sp-reserve-period__calendar-check"><i className="fa fa-check"></i></p>
              </div>
            </a>
          </td>
        );
      }
      else if (calendar.status == SMConst.RoomStatus.Full || calendar.status == SMConst.RoomStatus.Request) {
        classes.push("is-unavailable");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="sp-reserve-period__calendar-content" />
          </td>
        );
      }
      else {
        classes.push("is-closed");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="sp-reserve-period__calendar-content" />
          </td>
        );
      }

      if (cols.length == 7) {
        rows.push(<tr key={rows.length}>{cols}</tr>);
        cols = [];
      }
    });
    rows.push(<tr key={rows.length}>{cols}</tr>);
    return rows;
  }

  renderReserveStay(){
    if (!this.props.plan.has_stay_price) return;

    let checkinText = this.state.checkinAt ? this.toYMD(new Date(this.state.checkinAt),"/") : I18n.t("service.label_000403");
    let checkoutText = this.state.checkoutAt ? this.toYMD(new Date(this.state.checkoutAt),"/") : "-";

    let leftIsCurrentClassName = "";
    let rightIsCurrentClassName = "";

    let leftSettleClassName = "";
    let rightSettleClassName = "";

    if (this.state.isCheckinCalendar) {
      leftIsCurrentClassName = "sp-reserve-type__button sp-reserve-stay__switch is-current";
      leftSettleClassName = "sp-reserve-stay__switch-day";

      rightIsCurrentClassName = "sp-reserve-type__button sp-reserve-stay__switch";
      rightSettleClassName = "sp-reserve-stay__switch-day";
      if (!this.state.checkoutAt) {
        rightIsCurrentClassName += " is-disabled";
      }
      if (this.state.checkinAt && this.state.checkoutAt) {
        leftSettleClassName += " sp-reserve-stay__switch-day-settle";
        rightSettleClassName += " sp-reserve-stay__switch-day-settle";
      }
    } else {
      leftIsCurrentClassName = "sp-reserve-type__button sp-reserve-stay__switch";
      rightIsCurrentClassName = "sp-reserve-type__button sp-reserve-stay__switch is-current";

      leftSettleClassName = "sp-reserve-stay__switch-day sp-reserve-stay__switch-day-settle";

      if (!this.state.checkoutAt) {
        checkoutText = I18n.t("service.label_000403");
      }
      if (checkoutText == "-" || checkoutText == I18n.t("service.label_000403")) {
        rightSettleClassName = "sp-reserve-stay__switch-day";
      } else {
        rightSettleClassName = "sp-reserve-stay__switch-day sp-reserve-stay__switch-day-settle";
      }
    }
    return(
      <div className="sp-reserve-type sp-reserve-stay__type">
        <div onClick={(e) => this.checkinButtonDidClick(e)} className={leftIsCurrentClassName}>
          <strong className="sp-reserve-stay__switch-check">{I18n.t("service.label_000401")}</strong>
          <span className={leftSettleClassName}>{checkinText}</span>
        </div>
        <div onClick={(e) => this.checkoutButtonDidClick(e)} className={rightIsCurrentClassName}>
          <strong className="sp-reserve-stay__switch-check">{I18n.t("service.label_000402")}</strong>
          <span className={rightSettleClassName}>{checkoutText}</span>
        </div>
      </div>
    );
  }

  render() {

    const room = this.props.room;
    const yearText = sprintf("%s年", this.state.year);
    const monthText = sprintf("%s月", this.state.month);
    const timeStyle = {display: "none"};

    let className = "sp-reserve-card__inner__calendar sp-reserve__calendar-stay";
    if (this.state.isCheckinCalendar) {
      className += " is-checkin";
    } else {
      className += " is-checkout";
    }

    return(
      <div ref="calendarContainer" className="js-monthly-table__container sp-reserve-card">
        <div className="sp-reserve-card__inner clearfix">
          {this.renderReserveStay()}

          <div className={className}>
            <div className="sp-reserve-period__header">
              <a onClick={(e) => this.prevMonth(e)} href="#" className="sp-reserve-period__header-navi"><i className="fa fa-angle-left"></i></a>
              <h2 className="sp-reserve-period__title">{yearText}<span className="sp-reserve-period__title-month">{monthText}</span></h2>
              <a onClick={(e) => this.nextMonth(e)} href="#" className="sp-reserve-period__header-navi"><i className="fa fa-angle-right"></i></a>
            </div>
            <table ref="monthlyTable" className="js-monthly-table sp-reserve-period__calendar dashboard-calendar__table">
              <tbody>
              <tr>
                <th className="is-holiday">{I18n.t("datetime.Sun")}</th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Mon")}</div></th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Tue")}</div></th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Wed")}</div></th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Thu")}</div></th>
                <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Fri")}</div></th>
                <th className="is-holiday">{I18n.t("datetime.Sat")}</th>
              </tr>
              {this.renderMonthly()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
export default SMStayReservationCalendarMobileView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMStayReservationCalendarMobileView.jsx